import Style                                from "components/UI/main.module.scss";
import { GetSystemLabel }                   from "Utilities/utils";

export const NeedSaveBlock           = ({Boolean}) => {
    return(
        Boolean === true ? (
            <div className={[Style.row, Style.mb_2].join(" ")}>
                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                    <div className={[Style.rounded_3, Style.d_flex, Style.align_items_center, Style.border, Style.shadow_sm, Style.warning_bg].join(" ")}>
                        <span className={[Style.text_black, Style.fs_9, Style.p_1].join(" ")}>
                            {GetSystemLabel("ChangesNotSavedWarning")}
                        </span>
                    </div>
                </div>
            </div>
        )
        :
        null
    );
};
